

import { Component, OnInit, HostListener, ViewChildren, ViewChild } from '@angular/core';
import { SharedDataService } from '../../service/shared-data.service';
import * as $ from 'jquery';
import { Router } from '@angular/router';
import { GoogleAnalyticsService } from '../../service/google-analytics.service';
import { StaticDataService } from '../../service/static-data.service';
import { StaticViewDataService } from '../../service/static-view-data-service.service';
import { Config } from '../../config/config';
import { RestDataService } from '../../service/rest-data.service';
import { SnotifyService } from 'ng-snotify';
import { HttpClient } from '@angular/common/http';


@Component({
  selector: 'app-microsite',
  templateUrl: './microsite.component.html',
  styleUrls: ['./microsite.component.scss']
})



export class MicrositeComponent implements OnInit {
  activeMenu = 'micrositeList';
  isCompetitionFeedEnabled = false;
  isPrintFeedEnabled = false;
  domainConfig = null;
  isPhotoGalleryFeedEnabled = false;
  isHindiFeedEnabled = true;
  elementList = ['collection','embed','json-embed','input-form','chart','table']
  isLHPhotoGalleryFeedEnabled = false;
  isAffiliateFeedEnabled:any;
  enableStoryFeed:boolean;
  openCreateMicrositeFlag: boolean;
  openCreateTemplateFlag: boolean;
  
  SingleselectedFile: File;
  templateDropdownSettings = this.sharedService.getDropDownSettings(false, 'id', 'template');
  imageUploadInProgress: boolean;
  cropperImageUrl = {
    url: null,
    data: null,
    blobData: null
  };
  microsite = {};
  template = {
    name:'',
    pageCount: null,
    pageContentTemplate:[]
  };
  showLoader: boolean;
  @ViewChildren('templateInput') templateField;
  @ViewChild('templateList',{static: false}) templateList;
  @ViewChild('msListing',{static: false}) msListing;
  @ViewChild('templateListing',{static: false}) templateListing;
  currentSelection: number;
  filteredTemplateSuggestion: any = [];
  insideTemplate: boolean;
  templateQuery: string = '';
  templates = [];
  micrositePages =[];
  selectedTemplate: any;
  micrositeObject: any = {};
  logoGalleryFlag: boolean = false;
  showLogoCropper: boolean;
  logoBannerFlag: boolean;
  bannerGalleryFlag: boolean;
  showBannerCropper: boolean;

  constructor(
    private sharedService: SharedDataService,
    private router: Router,
    private gaService:GoogleAnalyticsService,
    private config: Config,
    private http: HttpClient,
    private restService: RestDataService,
    private snotify: SnotifyService,
  ) {
    this.sharedService.getCurrentDomainConfig(this.getDomainConfig.bind(this));
  }

  getDomainConfig(currentDomainConfig) {
    // console.log(currentDomainConfig);
    this.domainConfig = currentDomainConfig;
    this.isCompetitionFeedEnabled = this.sharedService.isdomainConfig('feeds','showCompetitionFeed');
    this.isPrintFeedEnabled = this.sharedService.isdomainConfig('feeds','showPrintFeed');
    this.isPhotoGalleryFeedEnabled = this.sharedService.isdomainConfig('feeds','showPhotoGalleryFeed');
    this.isLHPhotoGalleryFeedEnabled = this.sharedService.isdomainConfig('feeds','showLHPhotoGalleryFeed');
    this.isAffiliateFeedEnabled = this.sharedService.isdomainConfig('feeds','showAffiliateFeed');
    this.enableStoryFeed = this.sharedService.isdomainConfig('feeds','enableStoryFeed');
  //TODO:
    //this.isEconomistFeedEnabled = this.sharedService.isdomainConfig('feeds','showEconomistFeed')

    // this.isHindiFeedEnabled = this.sharedService.isdomainConfig('feeds','showHindiFeed');

  }
  ngOnInit() {
    this.sharedService.setTitle('Microsite');
    this.fetchTemplates();
    this.sharedService.getData().subscribe(x => {
      if (x === 'micrositeFlag') {
        console.log("micrositeFlag")
        this.openCreateMicrositeFlag = true;
      } else if(x === 'templateFlag') {
        this.openCreateTemplateFlag = true;
        console.log("templateFlag")
      }
    });
  }

  focusInSuggest(model) {
    if (model === 'template') {
      this.insideTemplate = true;
      if (this.templateQuery === '') {
        console.log(this.templates)
        this.filteredTemplateSuggestion = this.templates;
      }
    }
  }

  addLogo(ev, type) {
    console.log(ev)
    this.logoGalleryFlag = false;
    this.bannerGalleryFlag = false;
    if(ev.type === 'wire') {
      // this.saveCard(ev, 'elements');
      const defaultImagecardData = JSON.parse(JSON.stringify(StaticDataService.defaultImageCardData));
      defaultImagecardData.domainId = sessionStorage.getItem(StaticDataService.domainLiteral);
      const fd = new FormData();
      fd.set('file', ev.id);
      this.http.post(this.config.get('product').imageUploadUrl + this.config.get('product').imageUploadByUrlEndPoint, fd).
      subscribe(res => {
        // console.log(res);
        if (defaultImagecardData && res && !res.hasOwnProperty('error')) {
          console.log(res)
          const elementImageURL = this.sharedService.getImageOnPriority(res['images'], 'original');
            const imageUrl = this.config.get('product').baseUrl + StaticDataService.proxyImage + elementImageURL;
            this.sharedService.createObjectFromImageUrl(imageUrl, (data, reader) => {
              if (data !== false) {
                console.log("image data : 1 :: ", data);
                this.openCropper(false, data, type);
              } else {
                this.snotify.error('Image path does not exist.', '', this.sharedService.getConfig(false));
              }
            });
        }});
    } else {
      this.restService.http_get(
        this.config.get('product').baseUrl
        + this.config.getEndPoint(this.config.get('views'), 'element', 'get_element')
        + '/' + ev.id
      )
        .subscribe(result => {
          console.log(type + ' IMAGE');
          const elementImageURL = this.sharedService.getImageOnPriority(result['image']['images'], 'original');
            const imageUrl = this.config.get('product').baseUrl + StaticDataService.proxyImage + elementImageURL;
            this.sharedService.createObjectFromImageUrl(imageUrl, (data, reader) => {
              if (data !== false) {
                console.log("image data : 1 :: ", data);
                this.openCropper(false, data, type);
              } else {
                this.snotify.error('Image path does not exist.', '', this.sharedService.getConfig(false));
              }
            });
          // this.tempOtherAffiliateData.get('logo').setValue(result.image.images.original);
          
        },
          err => {
            this.snotify.error('Image could not be added', '', this.sharedService.getConfig(false));
          });
    }
  
  }


  openCropper(isCropForLeadMedia, data, model) {
    this.cropperImageUrl.data = data.data;
    this.cropperImageUrl.url = data.url;
    if (model === 'logo') {
      this.showLogoCropper = true;
    } if(model === 'banner') {
      this.showBannerCropper = true;
      console.log("wotkinhggggg")
    }

  }

  finishCropping(event, model) {
    console.log('finishCropping  Prodcut called');
    const requests = event.cropRequests;
    const verticalFlag = event.verticalFlag;
    const differentLeadFlag = event.differentImage;
    this.cancelCropping();
    this.sharedService.croppingSequence(requests, differentLeadFlag, data => {
      if (!data.hasOwnProperty('error')) {
        const { ampFlag, imagemap } = data;
        let obj = { images: data.imagemap}

        if(model === 'logo') {
          let logoImage = obj.images["90x90"];
          this.microsite['logo'] = logoImage;
        } 
        if(model === 'banner') {
          let logoImage = obj.images["1600x900"];
          this.microsite['banner'] = logoImage;
        } 
        
      } else {
        this.snotify.error('Image cropping failed', '', this.sharedService.getConfig(false));
      }
    });
  }

  cancelCropping() {
    this.showLogoCropper = false;
    this.showBannerCropper = false;
    this.cropperImageUrl = {
      url: null,
      data: null,
      blobData: null
    };
    this.imageUploadInProgress = false;
  }

  focusOutSuggest(model) {
  }

  selectAutoComplete(model, item) {
    if (model === 'template') {
      this.templateQuery = item.name;
      this.selectedTemplate = item;
      this.filteredTemplateSuggestion = [];
      this.insideTemplate = false;
      console.log(this.selectedTemplate)
      for(let i = 0; i < this.selectedTemplate.pageCount; i++) {
        console.log(i)
        this.micrositePages.push({'label':'','url':''});
        // this.micrositePages[i]['url'] = '';
      }
      console.log(this.micrositePages)
    }

  }

  onFileChangeSingle(event, model) {
    let file_name = <File>event.target.files[0].name;
    const reader = new FileReader();
    if (model === 'leadMedia') {
      console.log('file uplaod called');
      
    } else if ( model === 'logo' || model === 'banner') {
      // console.log('file uplaod called');
      const fd = new FormData();
      this.SingleselectedFile = <File>event.target.files[0];
      // console.log(this.SingleselectedFile);
      this.imageUploadInProgress = true;
      if (event.target.files && event.target.files.length > 0) {
        if ((typeof event.target.files[0]) === 'object') {
          // console.log(event.target.files[0]);
          if ((this.SingleselectedFile.size / 1000000) <= 11) {
            const a = reader.readAsDataURL(event.target.files[0]);
            reader.onload = (e: any) => {
              this.sharedService.checkImageForAMP(reader, flag => {
                if (flag) {
                  if (model === 'logo') {
                    this.uplaodImageAndOpenCropper(this.SingleselectedFile, e.target.result, 'logo');
                  } else if (model === 'banner') {
                    this.uplaodImageAndOpenCropper(this.SingleselectedFile, e.target.result, 'banner');
                  }

                } else {
                  this.sharedService.showAMPConfirmPopup(() => { // yes
                      if (model === 'logo') {
                      this.uplaodImageAndOpenCropper(this.SingleselectedFile, e.target.result, 'logo');
                    } else if (model === 'banner') {
                      this.uplaodImageAndOpenCropper(this.SingleselectedFile, e.target.result, 'banner');
                    }
                  },
                    () => { // no
                      this.SingleselectedFile = null;
                      this.imageUploadInProgress = false;
                    }
                  );
                }
              });
            };
          } else {
            this.SingleselectedFile = null;
            this.imageUploadInProgress = false;
            this.snotify.error('Image size exceeds 12 MB', '', this.sharedService.getConfig(false));
          }
        }
      }
      event.target.value = null;
      // this.isLightbox = false;
      // this.leadMediaImageToggle = false;
      // this.leadMediaHomeImageToggle = false;
      // this.inlineImageToggle = false;
    }
  }

  catchTagFocus(event){}

  customFunc(ev) {
    if(this.template.pageContentTemplate.length !== this.template.pageCount) {
      for(let i=0; i<this.template.pageCount; i++)
      this.template.pageContentTemplate[i] = [];
    }

  }

  addLogoGallery() {
    this.logoGalleryFlag = true;
  }

  addBannerGallery() {
    this.bannerGalleryFlag = true;
  }
  
  saveTemplate() {
    if(this.template && (!this.template.name || !this.template.pageCount) ) {
      this.snotify.error('Enter both Template Name and Page Count to proceed', '', this.sharedService.getConfig(false));
      return 0;
    }

    if(this.template['name'] && this.template['name'].length > 100) {
      this.snotify.error('Name length should be 100 charecters or less! ', '', this.sharedService.getConfig(false));
      return 0;
    }
    this.restService.http_post(this.config.get('product').baseUrl+ "/api/cms/microsite/template",this.template,
            res => {
              this.openCreateTemplateFlag = false;
              this.templateListing.refreshListing()
              console.log(res);
            });
  }

  uplaodImageAndOpenCropper(imageFile, base64, type) {
    this.snotify.info('Uploading', '', this.sharedService.getConfig(false));
    this.sharedService.uploadImage(imageFile).
      subscribe(res => {
        this.cropperImageUrl.data = base64;
        this.cropperImageUrl.url = res['images']['original'];
      
        if(type === 'logo') {
          this.microsite['logo'] = res['images']['original'];
        } 
        else if(type === 'banner') {
          this.microsite['banner'] = res['images']['original'];
          // this.showLogoCropper = true;
        }
      },
        error => {
          this.SingleselectedFile = null;
          // this.SingleselectedGifFile = null;
          this.showLoader = false;
          this.imageUploadInProgress = false;
          this.snotify.error('Upload Failed', '', this.sharedService.getConfig(false));
        });
  }

  fetchTemplates(){
    this.http.get(this.config.get('product').baseUrl
    + '/api/cms/microsite/template/search?page=0&size=5000').subscribe(response => {
        if(response){
          this.templates = response['content'];
        }

    },(error)=>{
     this.snotify.error('Error While fetching Templates', '', this.sharedService.getConfig(false));
    //  this.temp
    });
  }

  @HostListener('document:click', ['$event'])
  handleClick(event) {
    const clickedComponent = event.target;
   
    if (this.templateField['_results'][0] && clickedComponent === this.templateField['_results'][0].nativeElement) {
      this.insideTemplate = true;
      if (this.templateQuery === '') {
        this.filteredTemplateSuggestion = this.templates;
        console.log(this.templates)
      }
    }
    
    this.currentSelection = 0;
  }
  closeMicrosite(){
    this.openCreateMicrositeFlag = false;
    this.openCreateTemplateFlag = false;
    this.microsite = {};
    this.template = {
      name:'',
      pageCount: null,
      pageContentTemplate:[]
    };
    this.selectedTemplate = null;
    this.templateQuery = '';
    this.micrositePages = [];
  }

  saveMicrosite() {
    let isFail = false;
    
    if(this.isEmpty(this.microsite['title']) || this.isEmpty(this.microsite['description']) || !this.selectedTemplate || this.isEmpty(this.micrositePages[0].url) )  {
      this.snotify.error('Fill Title, Description, Template to proceed!', '', this.sharedService.getConfig(false));
      isFail = true;
    }

    if(this.microsite['title'] && this.microsite['title'].length > 100) {
      this.snotify.error('Title length should be 100 charecters or less! ', '', this.sharedService.getConfig(false));
      isFail = true;
    }
    for(let i of this.micrositePages) {
      if(this.isEmpty(i.url) || !this.checkUrlValidate(i.url)) {
        console.log(i.url)
        isFail = true;
        this.snotify.error('Enter all valid URLs!', '', this.sharedService.getConfig(false));
        break;
      }
    }
    if(this.isEmpty)
    if(this.isEmpty(this.microsite['logo']) || this.isEmpty(this.microsite['banner']) )  {
      this.snotify.error('Upload Banner and Logo Images!', '', this.sharedService.getConfig(false));
      isFail = true;
    }
    this.micrositeObject["name"] = this.microsite['title'];
    this.micrositeObject["description"] = this.microsite['description'];
    this.micrositeObject["templateId"] = this.selectedTemplate.id;
    this.micrositeObject["url"] = this.micrositePages[0].url;
    this.micrositeObject["pageCount"] = this.selectedTemplate.pageCount;
    this.micrositeObject['pageUrls'] = [];
    for(let page of this.micrositePages) {
      this.micrositeObject['pageUrls'].push(page.url);
    }
    this.micrositeObject["logo"] = this.microsite['logo'];
    this.micrositeObject["banner"] = this.microsite['banner'];

    console.log(this.micrositeObject)

    if(isFail === false) {
      this.snotify.info('Creating microsite!', '', this.sharedService.getConfig(false));
    this.restService.http_post(this.config.get('product').baseUrl+ "/api/cms/microsite",this.micrositeObject,
                res => {
                  console.log(res)
                  if(!res.error) {
                    this.openCreateMicrositeFlag = false;
                    this.microsite = {};
                    this.closeMicrosite();
                    this.snotify.success('Microsite successfully created!', '', this.sharedService.getConfig(false));
                    this.msListing.refreshListing()
                  }
                  else {
                    this.snotify.error(res.error, '', this.sharedService.getConfig(false));
                    // this.microsite = {};
                  }
                 
                });
    }
    
  }
  removeMicroImage(model) {
    this.microsite[model] = ''
  }
   isEmpty(val){
    return (val === undefined || val == null || val.length <= 0) ? true : false;
  }

  snowplowAnalytics(name) {
    let feedName=name;
    let eventCategory='Feeds';
    let eventAction=sessionStorage.getItem(StaticDataService.tenantName) +" " +feedName +' Listing';
    let eventLabel='';
    let eventValue=null;
   this.googleAnalytics(eventCategory,eventAction,eventLabel,eventValue)
    const ur = this.router.routerState.snapshot.url;
    this.sharedService.analyticsCall((window.location.origin + ur), 'tab', [], name);
  }

  counter(i: number) {
    return new Array(i);
  }

  checkUrlValidate(url) {
    if(!url) {
      return true;
    }
    const pattern = /^\/[^\/\s]+(?:\/[^\/\s]+)?$/;
    return (pattern.test(url));
   }

  filterAutoCompleteUp(event, model) {
    // console.log("filterAutoCompleteUp: "+event);
    // console.log("filterAutoCompleteUp: "+model);
    if (event.keyCode !== 9 && event.keyCode !== 27 && event.key !== 'Enter') {
      if (model === 'template') {
        if (this.insideTemplate) {
          if (this.templateQuery.length > 0) {
            this.filteredTemplateSuggestion = this.templates.filter(function (el) {
              return el.name.toLowerCase().indexOf(this.templateQuery.toLowerCase()) > -1;
            }.bind(this));
            console.log(this.filteredTemplateSuggestion)
          } else {
            
          }
        } else {
          this.insideTemplate = true;
          this.filteredTemplateSuggestion = [];
        }

      } 

    }
    // this.currentSelection = 0;
    return true;
  }

  filterAutoCompleteDown(event, model) {
    // console.log("filterAutoCompleteDown"+event);
    // console.log("filterAutoCompleteDown"+model);
    if (event.key === 'Enter') {
      if (model === 'section') {
        this.insideTemplate = false;
        this.selectAutoComplete(model, this.filteredTemplateSuggestion[this.currentSelection]);
      }
    } else if (event.keyCode === 27) {
      event.preventDefault();
      this.insideTemplate = false;
      event.stopPropagation();
    } 
    else {
      this.currentSelection = 0;
    }
    // console.log(this.currentSelection);
    return true;
  }

  isTemplatePermission(){
    if(this.restService.userDetail && this.restService.userDetail.micrositeTemplateEditPermission){
      return true;
    }else{
      // this.router.navigateByUrl('/dash/workspace')
      return false
    }
  }


  googleAnalytics(eventCategory,eventAction,eventLabel,eventValue){
    this.gaService.gaEventView(eventCategory,eventAction,eventLabel,eventValue)
   }
}
